import { Modal } from 'antd';
import { Button, CloseIcon, Input, Subtitle } from './shared';
import { useDispatch, useSelector } from 'react-redux';
import { selectLang } from '../store/ui/ui.selector';
import { translate } from '../lib/lang.helper';
import { useState } from 'react';
import PicturesWall from './shared/pictures-wall/PicturesWall';
import { sendSingleRequest } from '../apis';
import { showFeedback } from '../store/ui/ui.actions';
import { selectProfile } from '../store/auth/auth.selector';
import { useHistory } from 'react-router-dom';

interface Props {
  visible: boolean;
  onClose: () => void;
}

const IssueReportModal = ({ visible, onClose }: Props) => {
  const dispatch = useDispatch<any>();
  const history = useHistory();
  const lang = useSelector(selectLang);
  const profile = useSelector(selectProfile);

  const [content, setContent] = useState<string>('');
  const [images, setImages] = useState<any[]>([]);
  const [disabled, setDisabled] = useState(false);

  const viewTicketsClick = () => {
    history.push('/issues');
    onClose();
  };
  const confirmClick = async () => {
    if (content.length <= 0) {
      window.alert(translate(lang, '_write_issue'));
      return;
    }
    setDisabled(true);

    const response = await sendSingleRequest(
      { content, images },
      'POST',
      'api/issue',
      true,
    );
    if (response.status) {
      dispatch(
        showFeedback({
          isMessage: true,
          message: translate(
            lang,
            'Thank you for your report! We will review it as soon as possible.',
          ),
          type: 'success',
          duration: 5000,
        }),
      );
      onClose();
    } else {
      window.alert(
        response.data?.message || translate(lang, '_failed_send_report'),
      );
      setDisabled(false);
    }
  };

  return (
    <Modal
      visible={visible}
      onCancel={onClose}
      footer={null}
      closable
      closeIcon={<CloseIcon />}
      width={700}
    >
      <div className='wrap'>
        <div className='mb-32 mt-32'>
          <Subtitle color='black-1' align='left' size={4} fontWeight={600}>
            {translate(lang, '_report_issue', profile?.name)}
          </Subtitle>
        </div>
        <div className='mb-17'>
          <Input
            placeholder={translate(lang, '_write_issue')}
            type='textarea'
            value={content}
            onChange={e => setContent(e.target.value)}
            disabled={disabled}
          />
        </div>
        <div className='mb-32'>
          <PicturesWall
            label={translate(lang, '_screenshots_images')}
            fileList={images}
            handleChangeImages={img => setImages(img)}
            disabled={disabled}
          />
        </div>
      </div>
      <div className='modal-button d-flex justify-between align-center'>
        <Button
          width={'small'}
          size={2}
          type='fill'
          color='blue'
          className='rsp-btn'
          onClick={viewTicketsClick}
          disabled={disabled}
        >
          {translate(lang, 'View My Tickets')}
        </Button>
        <Button
          width={'small'}
          size={2}
          type='fill'
          color='green'
          className='rsp-btn'
          onClick={confirmClick}
          disabled={disabled}
        >
          {translate(lang, 'Confirm')}
        </Button>
      </div>
    </Modal>
  );
};

export default IssueReportModal;
